import {InvestmentCategoryType} from '../../_types/selectOptionsTypes/investmentCategoryType';

export const investmentCategoryOptions: Array<InvestmentCategoryType> = [
  {value: 'UNSET', label: 'Unset'},
  {value: 'STABILIZED', label: 'Stabilized'},
  {value: 'VALUE_ADD', label: 'Value Add'},
  {value: 'VACANT', label: 'Vacant'},
];
